import { render } from "./DefaultLayout.vue?vue&type=template&id=d2680cca"
import script from "./DefaultLayout.vue?vue&type=script&lang=ts"
export * from "./DefaultLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script